import moment from "moment";
import {
  Card,
  Row,
  Col,
  Alert,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { BsInfoCircle, BsClipboardCheck, BsClock } from "react-icons/bs";
import { useSelector } from "react-redux";
import { formatUTCDate, formatUTCTime } from "../../utils/date";
import PulsePoint from "../pulse-point/PulsePoint";
import styles from "./bookingQuickView.module.scss";
import { RiShipLine } from "react-icons/ri";

type Props = {
  sticky?: boolean;
  showHeader?: boolean;
  departureCountry?: string;
  arrivalCountry?: string;
  departureAt?: string | null;
  arrivalAt?: string | null;
  duration?: string | null;
  company?: string | null;
  notes?: string;
  isTransit?: boolean;
};

const BookingQuickView = ({
  sticky,
  showHeader,
  departureCountry,
  arrivalCountry,
  departureAt,
  arrivalAt,
  duration,
  company,
  notes,
  isTransit,
}: Props) => {
  const profile = useSelector((state) => state.loginPage.profile);

  if (!profile) return null;

  return (
    <Card className={sticky ? styles.sticky : ""}>
      <Card.Body>
        {showHeader && (
          <>
            <Card.Title>
              <BsClipboardCheck /> Quick view
            </Card.Title>

            <hr />
          </>
        )}

        <Row>
          <Col className={styles.route}>
            <div className={styles.departureBlock}>
              <span>{departureCountry || "Select departure"}</span>
              {!!departureAt && (
                <>
                  <span>{formatUTCDate(departureAt)}</span>
                  <span>{formatUTCTime(departureAt)}</span>
                </>
              )}
            </div>
            <div>
              <PulsePoint variant="secondary" />
            </div>
            <div className={styles.routeLine} />
            <div className={styles.companyInfo}>
              <RiShipLine /> <span>{company}</span>
              {!!(!isTransit && duration) && (
                <span>
                  <BsClock /> {moment(duration, "HH:mm:ss").format("HH:mm")}{" "}
                  hours
                </span>
              )}
            </div>
            <div className={styles.routeLine} />
            <div>
              <PulsePoint variant="success" />
            </div>
            <div className={styles.arrivalBlock}>
              {!!arrivalAt && (
                <>
                  <span>{formatUTCTime(arrivalAt)}</span>
                  <span>{formatUTCDate(arrivalAt)}</span>
                </>
              )}
              <span>{arrivalCountry || "Select arrival"}</span>
            </div>
          </Col>
        </Row>

        <Row>
          <Col>
            {notes && (
              <Alert variant="info" style={{ marginBottom: "0px" }}>
                <OverlayTrigger
                  placement="top"
                  overlay={(props) => (
                    <Tooltip id="note-tooltip" {...props}>
                      Note
                    </Tooltip>
                  )}
                >
                  <span className={styles.noteAlert}>
                    <BsInfoCircle /> <span>{notes}</span>
                  </span>
                </OverlayTrigger>
              </Alert>
            )}
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default BookingQuickView;
